import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Shared
import { SharedModule } from '@app/shared/shared.module';

import { BaseComponent } from './base/base.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { SupportComponent } from './button-support/support.component';

import { AvatarModule } from 'primeng/avatar';

import { ContentAnimateDirective } from '@app/directives';

import { NgbDropdownModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [BaseComponent, NavbarComponent, SidebarComponent, FooterComponent, SupportComponent, 
    //directives
    ContentAnimateDirective],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    NgbDropdownModule,
    NgbCollapseModule,
    PerfectScrollbarModule,
    AvatarModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class LayoutModule { }
